import { render, staticRenderFns } from "./VehiculeLaCote.vue?vue&type=template&id=89a2abac&scoped=true&"
import script from "./VehiculeLaCote.vue?vue&type=script&lang=js&"
export * from "./VehiculeLaCote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a2abac",
  null
  
)

export default component.exports